<template>
	<div class="class" v-katex:auto>
		<teacherHeader :logo_name="logo_name" @info-event="myInfoEvent" @public-event="publicEvent"></teacherHeader>
		<div class="task_cont bg_blue">
			<div class="task_cont_div bg_white radius8 bs">
				<div class="flex famous_position">
					<div class="my_position_l cl_gray">
						<img src="../../../static/icon_position.png" class="mar5" />
						<p>当前位置：<router-link to="/task" class="cl_gray">布置作业</router-link>  >  试卷预览</p>
					</div>
					<div class="my_position_r cl_violet" @click="$router.go(-1)"><span class="mar5">返回上级</span><img src="../../../static/return_violet.png" /></div>
				</div>
				<div class="paper_details mat30">
					<div class="paper_list radius8 bs mab30" v-for="(item,index) in data.paperques" :key="index">
						<div class="paper_list_title f18px cl_dark">
							<div class="paper_list_title_l">{{index + 1}}、</div>
							<div class="paper_list_title_r" v-html="item.title"></div>
						</div>
						<div class="paper_list_check f16px cl_gray mat20" v-if="item.qtpye == '单选题' || item.qtpye == '多选题' || item.qtpye == '双选题' || item.qtpye == '选择题'">
							<div class="paper_list_check_list mat10" v-if="item.option_a != ''">
								<div class="paper_list_check_list_l">A、</div>
								<div class="paper_list_check_list_r" v-html="item.option_a"></div>
							</div>
							<div class="paper_list_check_list mat10" v-if="item.option_b != ''">
								<div class="paper_list_check_list_l">B、</div>
								<div class="paper_list_check_list_r" v-html="item.option_b"></div>
							</div>
							<div class="paper_list_check_list mat10" v-if="item.option_c != ''">
								<div class="paper_list_check_list_l">C、</div>
								<div class="paper_list_check_list_r" v-html="item.option_c"></div>
							</div>
							<div class="paper_list_check_list mat10" v-if="item.option_d != ''">
								<div class="paper_list_check_list_l">D、</div>
								<div class="paper_list_check_list_r" v-html="item.option_d"></div>
							</div>
							<div class="paper_list_check_list mat10" v-if="item.option_e != ''">
								<div class="paper_list_check_list_l">E、</div>
								<div class="paper_list_check_list_r" v-html="item.option_e"></div>
							</div>
						</div>
						<div class="" v-else>
							<div class="paper_list_check f16px cl_gray mat20" v-if="item.isSub == 1">
								<div class="paper_list_check_list mat10" v-for="(second,index) in item.subquestions" :key="index" :id="second.id">
									<div class="paper_list_check_list_l">{{index + 1}}、</div>
									<div class="paper_list_check_list_r" v-html="second.title"></div>
								</div>
							</div>
						</div>
						<div class="paper_list_btm flex">
							<p class="f16px cl_dark">难度：
								<span class="cl_yel" v-if="item.diff == 1">非常简单</span>
								<span class="cl_yel" v-if="item.diff == 2">简单</span>
								<span class="cl_yel" v-if="item.diff == 3">一般</span>
								<span class="cl_yel" v-if="item.diff == 4">难</span>
								<span class="cl_yel" v-if="item.diff == 5">非常难</span>
							</p>
							<button class="cl_dark bg_white" @click="feedback(item.id)">报错</button>
						</div>
						<div class="paper_list_analysis cl_dark" :class="{'on': item.select}">
							<div class="paper_list_analysis_item">
								<div class="f18px">答案：</div>
								<div class="f16px paper_list_analysis_item_r" v-html="item.answer2"></div>
							</div>
							<div class="paper_list_analysis_item mat10">
								<div class="f18px">解析：</div>
								<div class="f16px paper_list_analysis_item_r" v-html="item.parse"></div>
							</div>
						</div>
						<div class="paper_list_select tc cl_violet cur" :class="{'on': item.select}" @click="select(index)">
							<p>{{item.select ? '收起' : '展开'}}解析</p>
							<img src="../../../static/select_violet.png" class="bg_white radius" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import teacherHeader from '../../components/teacher_header.vue'
	
	export default {
		name: 'paper_details',
		components: {
			teacherHeader,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				logo_name: "试卷预览",
				id: "",
				data: {},
			}
		},
		created() {
			this.id = this.$route.query.id;
		},
		mounted() {
			this.getList();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//试卷题目
			getList () {
				this.$get("/api/funlearning/get_papers_questions_data",{
					token: localStorage.getItem("token"),
					id: this.id,
				})
				.then(res => {
					for (let i = 0; i < res.data.paperques.length; i++) {
						res.data.paperques[i].select = false;
					}
					this.data = res.data;
				});
			},
			select (e) {
				if (this.data.paperques[e].select) {
					this.data.paperques[e].select = false;
				} else {
					this.data.paperques[e].select = true;
				}
			},
		},
	}
</script>

<style>
</style>
